import {
  GET_PROMOTER_REQUEST,
  GET_PROMOTER_SUCCESS,
  GET_PROMOTER_FAIL,
  UPDATE_PROMOTER_REQUEST,
  UPDATE_PROMOTER_SUCCESS,
  UPDATE_PROMOTER_FAILURE,
  CLEAR_PROMOTER,
  GET_MY_PROMOTER_SUCCESS,
  GET_PROMOTER_FINANCIALS_REQUEST,
  GET_PROMOTER_FINANCIALS_SUCCESS,
  GET_PROMOTER_FINANCIALS_FAIL,
} from '../actions/promoter';
import { LOGOUT } from '../actions/auth';

const initialState = {
  // Whichever promoter profile was fetched last — often someone else's, since
  // event and brand pages load the promoter they belong to.
  promoter: null,
  // The signed-in promoter's own profile, and only ever theirs. Read this for
  // anything that decides what the current user may do (the Easypay gate,
  // T2B-423): `promoter` can hold a stranger at any moment.
  me: null,
  loading: false,
  error: null,
  // Dados Financeiros. Separate flags from `loading`/`error` above, which the
  // Dashboard uses to decide whether to block the entire page.
  financials: null,
  financialsLoading: false,
  financialsError: null,
};

const promoterReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROMOTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PROMOTER_SUCCESS:
      return {
        ...state,
        promoter: action.payload,
        loading: false,
        error: null,
      };
    case GET_PROMOTER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_PROMOTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_PROMOTER_SUCCESS:
      return {
        ...state,
        loading: false,
        promoter: action.payload,
      };
    case UPDATE_PROMOTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_MY_PROMOTER_SUCCESS:
      return {
        ...state,
        me: action.payload,
      };
    case GET_PROMOTER_FINANCIALS_REQUEST:
      return { ...state, financialsLoading: true, financialsError: null };
    case GET_PROMOTER_FINANCIALS_SUCCESS:
      return {
        ...state,
        financialsLoading: false,
        financials: action.payload,
        financialsError: null,
      };
    case GET_PROMOTER_FINANCIALS_FAIL:
      return {
        ...state,
        financialsLoading: false,
        financialsError: action.payload,
      };
    // Dispatched when a page stops showing a promoter's profile (leaving an
    // event page, say) — it clears the viewed profile, not who we are. Wiping
    // `me` here would knock the Easypay gate back to "unknown" every time a
    // promoter opened an event page, and send AuthBootstrapper off to refetch
    // a profile that hadn't changed.
    case CLEAR_PROMOTER:
      return { ...initialState, me: state.me, financials: state.financials };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default promoterReducer;
